import Token from './Token';

export default class ParenthesesCloseToken implements Token {}


// WEBPACK FOOTER //
// ./code/project/modules/parsing/tokens/ParenthesesCloseToken.ts